/** @jsx h */
import { h, Component, Fragment } from 'preact'
import { pageViewEvent } from '../../utils/analytics'
import ClaimCardPJ from '../claims/ClaimCardPJ'
import VideoSlideContent from './VideoSlideContent'

class Slide extends Component {
  componentDidMount () {
    const { href, id } = this.props
    pageViewEvent(`${href}/stages/${id}`)
  }

  render () {
    const {
      description,
      featuredImageUrl,
      videoUrl,
      index,
      claims,
      title,
      sliderId,
      populateDrawer
    } = this.props

    const proofPoints = [...claims]
    if (videoUrl) {
      return this.videoSlide(description, videoUrl, index, proofPoints, title, sliderId, populateDrawer)
    } else {
      return this.imageSlide(description, featuredImageUrl, index, proofPoints, title, sliderId, populateDrawer)
    }
  }

  videoSlide (description, videoUrl, index, proofPoints, title, sliderId, populateDrawer) {
    return (
      <article
        id={`${sliderId}-${index + 1}`}
        class='Journey'
      >
        <VideoSlideContent
          description={description} proofPoints={proofPoints} title={title}
          populateDrawer={populateDrawer} videoUrl={videoUrl}
        />
      </article>
    )
  }

  imageSlide (description, featuredImageUrl, index, proofPoints, title, sliderId, populateDrawer) {
    const viewStyle = {}
    if (featuredImageUrl) {
      viewStyle.backgroundImage = `url(${featuredImageUrl})`
    }
    const imageToggle = featuredImageUrl ? 'with' : 'no'

    return (
      <article
        id={`${sliderId}-${index + 1}`}
        class={`Journey Journey--${imageToggle}Image`}
        style={viewStyle}
      >
        <div className='Journey-content noselect'>
          <SlideContent
            description={description} proofPoints={proofPoints} title={title}
            populateDrawer={populateDrawer}
          />
        </div>
      </article>
    )
  }
}

const SlideContent = ({ description, proofPoints, title, populateDrawer }) => (
  <Fragment>
    <h1 className='Journey-title'>{title}</h1>
    <p className='Journey-description'>{description}</p>
    {proofPoints && proofPoints.length > 0 &&
      <div className='Journey-items--proofPoints'>
        <ClaimCardPJ
          {...proofPoints[0]}
          populateDrawer={populateDrawer}
        />
      </div>}
  </Fragment>
)

export default Slide
export { SlideContent }
